import { BaseService } from './baseservice';

class HrServiceClass extends BaseService {

    getFieldModel(field){
        switch(field){
            case 'req_id': 
            case 'name':
            case 'department':
            case 'job_title':
            case 'source':
            case 'agency':
            case 'post_date':
            case 'hire_date': 
            case 'job_role':
            case 'target_hire_date':
            case 'resume_received':
                return 'candidates';
            case 'employee_id': 
            case 'manager':
            case 'location':
            case 'backfill':
            case 'backfill_for':
            case 'target_base_salary':
            case 'target_variable_compensation':
            case 'tcc_ote': 
            case 'recruiting_strategy':
            case 'status':
            case 'applicant_count': 
            case 'agency_fees':
            case 'posting_fees': 
            case 'se_td':
                return 'staff';
            default:
                return "termination_censuses";
        }
    }

    async import(body, url) {
        const response = await this.fetch('POST', url, body, 'multipart/form-data');

        if (response && response.data) {
            return response.data;
        }

        return [];
    }
}

let HRService = new HrServiceClass();
export default HRService;